// extracted by mini-css-extract-plugin
export default {"form":"CityAliasForm_form__DFY2i","actions":"CityAliasForm_actions__J9mv0","deleteButton":"CityAliasForm_deleteButton__rDpfm"};